import { useSettings } from "@/context/SettingsContext";
import CTAButtons from "@/components/CTAButtons";
import InquiryDialog from "@/components/InquiryDialog";
import { Button } from "@/components/ui/button";
import { Phone, MapPin, Mail, Clock } from "lucide-react";

export default function Contact() {
  const { settings } = useSettings();
  const s = settings || {};
  return (
    <div className="pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-6">
          <div className="text-xs uppercase tracking-[0.24em] text-amber-600 mb-4">Contact</div>
          <h1 className="font-display text-5xl sm:text-6xl text-slate-950 leading-none">Let&apos;s plan your escape.</h1>
          <p className="mt-6 text-slate-600 leading-relaxed">Reach us any way you prefer — a curator will respond within 24 hours.</p>
          <div className="mt-10 space-y-5 text-slate-700">
            {s.phone_primary && <div className="flex items-center gap-4"><Phone className="w-4 h-4 text-amber-600" /><a href={`tel:${s.phone_primary}`} className="hover:text-slate-950" data-testid="contact-phone">{s.phone_primary}</a></div>}
            {s.email && <div className="flex items-center gap-4"><Mail className="w-4 h-4 text-amber-600" /><a href={`mailto:${s.email}`} className="hover:text-slate-950">{s.email}</a></div>}
            {s.address && <div className="flex items-start gap-4"><MapPin className="w-4 h-4 text-amber-600 mt-1" /><span>{s.address}</span></div>}
            {s.business_hours && <div className="flex items-center gap-4"><Clock className="w-4 h-4 text-amber-600" /><span>{s.business_hours}</span></div>}
          </div>
          <div className="mt-10"><CTAButtons label="a custom journey" sourceRef="contact" testIdPrefix="contact" /></div>
        </div>
        <div className="lg:col-span-6">
          <div className="rounded-2xl border border-slate-200 bg-white p-8">
            <div className="text-xs uppercase tracking-[0.24em] text-amber-600">Send inquiry</div>
            <div className="mt-2 font-display text-3xl text-slate-950">Craft your itinerary.</div>
            <p className="text-slate-600 mt-2">Tell us about your travel dreams — a curator will design a bespoke plan.</p>
            <div className="mt-6">
              <InquiryDialog triggerTestId="contact-page-inquiry-btn">
                <Button className="bg-slate-950 hover:bg-slate-800 rounded-full px-6" data-testid="contact-page-inquiry-btn">Open inquiry form →</Button>
              </InquiryDialog>
            </div>
          </div>
          {s.google_maps_url && (
            <div className="mt-6 rounded-2xl overflow-hidden border border-slate-200 aspect-[4/3]">
              <iframe title="Location" src={`https://maps.google.com/maps?q=${encodeURIComponent(s.address || "Bengaluru")}&output=embed`} className="w-full h-full" loading="lazy" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
